export default __webpack_public_path__ + "static/media/ps-car-3.ce2df943.jpg";